<template>
  <div class="sag-grid-data-view">

    <!-- Title & SubTitle -->
    <div class="my-1">
      <b-card-title>{{ title }}</b-card-title>
      <b-card-sub-title>
        {{ subtitle }}
      </b-card-sub-title>
    </div>

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <!-- grid button (e.g. Insert Button)-->
      <b-col>
        <slot></slot>
      </b-col>

      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <vue-good-table 
      :id="'vgt-' + GridData.name"
      :columns="tableColumns" 
      :rows="tableRows"
      @on-row-click="onRowClick"
      :line-numbers="cptOptions.lineNumber"
      :search-options="{
        enabled: true,
        placeholder: 'Search this table',
        externalQuery: searchTerm 
      }"
      :select-options="{
        enabled: cptOptions.selectCheckBox,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength
      }"
    >

      <!-- Filter 過濾 -->
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field !== 'action'" class="text-nowrap">
            <i class="fa fa-address-book"></i> {{ props.column.label }}
            <span @click="filterActive($event, props.column.filterOptions)">
              <b-icon-funnel v-if="!props.column.filterOptions.enabled"></b-icon-funnel>
              <b-icon-funnel-fill v-else></b-icon-funnel-fill>
            </span>
        </span>
        <span v-else  class="text-nowrap">
          <i class="fa fa-address-book"></i> {{ props.column.label }}
        </span>
      </template>

      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="previewModalOpen">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Preview</span>
              </b-dropdown-item>
              <b-dropdown-item @click="editModalOpen">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item v-b-modal="'modal_' + GridData.name">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>

      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['5','10','20','30']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage: value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    
    <hr v-if="cptOptions.multiple"/>

    <slot name="sub-grid"></slot>

    <b-modal 
      :id="'modal_' + GridData.name"
      centered
      @ok="deleteData"
    >
      <div class="text-center">是否刪除資料？</div>
      <div v-if="!GridData.isChild" class="mt-3 text-danger">提醒：將會連同單身一起刪除</div>
    </b-modal>

    <slot name="editModal"></slot>
    <slot name="previewModal"></slot>

  </div>
</template>
<script>
import SagCard from '@/components/basic/SagCard.vue'
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table'
import SagBasicTable from './SagBasicTable'
import { defaultOptions } from './SagBasicTable'

import { 
  // icon
  BIconFunnel, 
  BIconFunnelFill,
  // tag
  BFormGroup, 
  BFormInput,
  BCardTitle, 
  BCardSubTitle, 
  BFormSelect, 
  BPagination, 
  BDropdown, 
  BDropdownItem,
  BModal,
  BButton,
  BCol
} from 'bootstrap-vue'
export default {
  components: {
    VueGoodTable,
    BCardSubTitle,
    SagCard,
    BCardTitle,
    BFormSelect,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormGroup, 
    BFormInput,
    BIconFunnel,
    BIconFunnelFill,
    BModal,
    BButton,
    BCol
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    GridData: {
      type: Object,
      required: true
    },
    serviceName: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: defaultOptions
    }
  },
  setup(props, { emit }){

    const {
      searchTerm,
      pageLength,
      filterActive,
      deleteData,
      onRowClick,
      tableColumns,
      tableRows,
      previewModalOpen,
      editModalOpen,
      cptOptions
    } = SagBasicTable(props, emit)


    return {
      searchTerm,
      pageLength,
      filterActive,
      deleteData,
      onRowClick,
      tableColumns,
      tableRows,
      previewModalOpen,
      editModalOpen,
      cptOptions
    }
  }
}
</script>

<style lang="scss">
.Cursort-cell{
  background: #ced8df !important;
  th {
    background: none !important;
  }
}
</style>